/**
 * Rakhi category circles.
 *
 * The circles are plain links — clicking one navigates to that collection page
 * so the whole page (banners, filters, grid) renders for it. The only JS left
 * is the deselect cross, which can't be a nested <a> inside the circle link.
 * Active state is decided in Liquid.
 */
if (!customElements.get('rakhi-category-nav')) {
  class RakhiCategoryNav extends HTMLElement {
    connectedCallback() {
      this.addEventListener('click', (evt) => {
        const deselect = evt.target.closest('[data-deselect]');
        if (!deselect || !this.dataset.baseUrl) return;
        evt.preventDefault();
        window.location.href = this.dataset.baseUrl;
      });
    }
  }

  customElements.define('rakhi-category-nav', RakhiCategoryNav);
}
